import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { functionpermissionemployee } from '../client-employee-contact/client-employee-contact.model';
import { functionpermission } from '../client-parent/client-parent.model';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { ClientEmployeeRelationshipBO, GetRelationalShipBO, saveEmployerEmployeeRelationshipBO } from './client-employee-relationship.modal';
import { ClientEmployeeRelationshipService } from './client-employee-relationship.service';
import { RelationshipDateService } from './client-employee-relationshipdateservice';
import { budgetService } from '../budgetplan-form/budgetplan-form.service';


@Component({
  selector: 'app-client-employee-relationship',
  templateUrl: './client-employee-relationship.component.html',
  styleUrls: ['./client-employee-relationship.component.scss']
})
export class ClientEmployeeRelationshipComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() CERelation: ClientEmployeeRelationshipBO;
  @ViewChild('gridRelationship') public gridRelationship: GridComponent;

  saveRelationshipInfo: saveEmployerEmployeeRelationshipBO = new saveEmployerEmployeeRelationshipBO();
  RelationShipFilterBo: GetRelationalShipBO = new GetRelationalShipBO();
  fpclient: functionpermission = new functionpermission();
  fpemployee: functionpermissionemployee = new functionpermissionemployee();
  disabledsavedbutton:boolean=false;
  public GridData: Observable<DataStateChangeEventArgs>;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  public filterSettings: object;
  RelationshipStatusList: any = [];
  AllRelationshipStatusList: any = [];
  RelationshipDropdown: any = [];
  ServiceDropdown:any=[];
  EmployeeDropdown: any = [];
  ClientDropdown: any = [];
  

  constructor(public global: GlobalComponent, public generalservice: GeneralService,
    public formBuilder: FormBuilder,
    public RService: ClientEmployeeRelationshipService,
    public ClientService: ClientHttpService,
    public DateService: RelationshipDateService,
    public toasterservice: ToastrService,public budgetService:budgetService) {
    this.global.checkforlogout();
    this.GridData = DateService;
  }
 
  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    if (this.CERelation.RelationshipType == 'Client') {
      this.RelationShipFilterBo.field = "clientName";
      this.RelationShipFilterBo.orderColumn = "clientName";
      this.RelationShipFilterBo.clientId=this.CERelation.Id
      this.getpermissionclient()
      this.GetEmployeeDropDown();
      this.getFilter();
      this.getServicesDropdown(this.global.clientId);
    }
    else if (this.CERelation.RelationshipType == 'Employee') {
      this.getpermissionemployee()
      this.RelationShipFilterBo.field = "employeeName";
      this.RelationShipFilterBo.orderColumn = "clientName";
      this.GetClientDropdown();
       this.RelationShipFilterBo.employeeId=this.CERelation.Id
    this.getFilter();
    }
    this.getRelationshipStatus();
    this.getRelationshipStatusfilter();
    this.getRelationshipDropdown();
    
  }
  getpermissionclient() {
    let params = new URLSearchParams();
    params.append("pagecode", "Client");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.ClientService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fpclient = data;

      }
      else {
        this.fpclient = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fpclient = new functionpermission();
      })
  }
  getpermissionemployee() {
    let params = new URLSearchParams();
    params.append("pagecode", "employee");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.ClientService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fpemployee = data;

      }
      else {
        this.fpemployee = new functionpermissionemployee();
      }
    },
      (err: HttpErrorResponse) => {
        this.fpemployee = new functionpermissionemployee();
      })
  }
  //......................................getRelationshipStatus........................................
  getRelationshipStatus() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.RService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.RelationshipStatusList = data;
      this.saveRelationshipInfo.statusLid = this.RelationshipStatusList.filter(st => st.lovCode == "ACTIVE")[0].id;
    })
  }
  getRelationshipStatusfilter() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.RService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AllRelationshipStatusList = data;   
    let value =
      {
        "id": null,
        "lovName": "ALL",
        "lovCode": "ALL",
        "lovValue": "ALL"
      }
      this.AllRelationshipStatusList.push(value);
    })
  }
  //..................................................GetEERelationshipwithTax..................................
  GetEERelationshipwithTax() {
    let params = new URLSearchParams();
    params.append("employerEmployeeRelationshipId", this.saveRelationshipInfo.id);
    this.RService.GetEERelationshipwithTax(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
   
      this.saveRelationshipInfo.relationshipTaxes = data.relationshipTaxes;
    })
  }
  //......................................getRelationshipDropdown........................................
  getRelationshipDropdown() {
    this.RService.GetRelationshipDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.RelationshipDropdown = data;
    })
  }
   getServicesDropdown(clientId) {
      let params = new URLSearchParams();
    params.append("ServiceGroupName", "Personal Assistance");
    params.append("clientId",clientId);
     this.budgetService.getAuthServiceDropdownForAdmin(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.ServiceDropdown = data;
      }, (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      });
  }
  //......................................GetAllTaxes........................................
  GetAllTaxes() {
    this.RService.GetAllTaxes().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.saveRelationshipInfo.relationshipTaxes = [];
      data?.forEach(element => {
        let taxesDetails = {
          "taxId": element.id,
          "taxName": element.name,
          "taxable": false
        }
        this.saveRelationshipInfo.relationshipTaxes.push(taxesDetails)
      });
    })
  }
  //......................................GetClientDropdown........................................
  GetClientDropdown() {
    this.RService.GetClientDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientDropdown = data;
    })
  }
  //......................................GetEmployeeDropDown........................................
  GetEmployeeDropDown() {
    this.RService.GetEmployeeDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EmployeeDropdown = data;
    })
  }
  // ................................................dataChangeRelationship..............................................
  public dataChangeRelationship(R): void {
    let val = (R.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((R.sorted || []).length) {
        this.RelationShipFilterBo.orderColumn = R.sorted[0].name;
        this.RelationShipFilterBo.orderType = R.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && R.action.action != "clearFilter") {
      this.RelationShipFilterBo.value = R.action.currentFilterObject.value;
      this.RelationShipFilterBo.field = R.action.currentFilterObject.field;
      this.RelationShipFilterBo.matchCase = R.action.currentFilterObject.matchCase;
      this.RelationShipFilterBo.operator = R.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && R.action.action == "clearFilter") {
        if (this.CERelation.RelationshipType == 'Client') {
          this.RelationShipFilterBo.field = "clientName";
          this.RelationShipFilterBo.matchCase = false;
          this.RelationShipFilterBo.operator = "contains";
          this.RelationShipFilterBo.value = "";
          this.RelationShipFilterBo.type = "string";
        }
        else if (this.CERelation.RelationshipType == 'Employee') {
          this.RelationShipFilterBo.field = "employeeName";
          this.RelationShipFilterBo.matchCase = false;
          this.RelationShipFilterBo.operator = "contains";
          this.RelationShipFilterBo.value = "";
          this.RelationShipFilterBo.type = "string";
        }
      }
    }
    this.getFilter();
    if (val == "paging" && R.action.name == "actionBegin") {   
    }
  }
  //.........................................onActionRelationship.....................................................
  public onActionRelationship(R) {
    this.RelationShipFilterBo.currentpageno = this.gridRelationship.pagerModule.pagerObj.currentPage;
    this.RelationShipFilterBo.pageitem = this.gridRelationship.pagerModule.pagerObj.pageSize;
    if (R.name == "actionBegin" && R.requestType == "filterbeforeopen") {
      this.RelationShipFilterBo.type = R.columnType
    }
  }
  //...........................................getFilter...............................................
  getFilter() {
    if (this.CERelation.RelationshipType == 'Client') {
      this.RelationShipFilterBo.field = "clientName";
      this.RelationShipFilterBo.orderColumn = "clientName";
      this.RelationShipFilterBo.clientId=this.CERelation.Id
    }
    else if (this.CERelation.RelationshipType == 'Employee') {
      this.RelationShipFilterBo.field = "employeeName";
      this.RelationShipFilterBo.orderColumn = "clientName";    
       this.RelationShipFilterBo.employeeId=this.CERelation.Id    
    }

    this.DateService.execute(this.RelationShipFilterBo);
    let count = 0;
    this.GridData.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridRelationship.height = '500';
      }
      else {
        this.gridRelationship.height = 'auto';
      }
    })
  }
  //..........................................SaveOrUpdateRelationship.....................................
  SaveOrUpdateRelationship() {
    this.disabledsavedbutton = true;
    let saveRel: saveEmployerEmployeeRelationshipBO = JSON.parse(JSON.stringify(this.saveRelationshipInfo));
    saveRel.id = this.saveRelationshipInfo.id;
    if (this.CERelation.RelationshipType == 'Client') {
      saveRel.employeeId = this.saveRelationshipInfo.employeeId;
      saveRel.clientId = this.CERelation.Id;
    }
    else if (this.CERelation.RelationshipType == 'Employee') {
      saveRel.employeeId = this.CERelation.Id;
    }
    saveRel.relationshipId = this.saveRelationshipInfo.relationshipId;
    this.RService.SaveEERelationship(saveRel).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.disabledsavedbutton = false;
      if (data) {
        if (this.saveRelationshipInfo.id == '00000000-0000-0000-0000-000000000000') {
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
          this.toasterservice.success('Relationship saved successfully!');
        }
        else if (this.saveRelationshipInfo.id != '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Relationship updated successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        }
        document.getElementById('openRelationshipModal').click();
        this.saveRelationshipInfo = new saveEmployerEmployeeRelationshipBO();
        if (this.CERelation.RelationshipType == 'Client') {
          this.RelationShipFilterBo.field = "clientName";
          this.RelationShipFilterBo.orderColumn = "clientName";
        }
        else if (this.CERelation.RelationshipType == 'Employee') {
          this.RelationShipFilterBo.field = "employeeName";
          this.RelationShipFilterBo.orderColumn = "clientName";
        }
        this.saveRelationshipInfo.statusLid = this.RelationshipStatusList.filter(st => st.lovCode == "ACTIVE")[0].id;
        this.getFilter();
      }
    }, (err: any) => {
      this.disabledsavedbutton = false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }
  //..........................................getDetails..................................................
  getDetails(saveBos: saveEmployerEmployeeRelationshipBO) {
    this.saveRelationshipInfo = JSON.parse(JSON.stringify(saveBos));
    this.GetEERelationshipwithTax();
    this.getServicesDropdown(this.saveRelationshipInfo.clientId);
  }
  BasedonClient(val) {   
    if(val != null && val != undefined)
      this.getServicesDropdown(val);
  }
  //..........................................clearRelationalship..................................................
  clearRelationalship() {
    this.saveRelationshipInfo = new saveEmployerEmployeeRelationshipBO();
    this.saveRelationshipInfo.statusLid = this.RelationshipStatusList.filter(st => st.lovCode == "ACTIVE")[0].id;
  }
  //.....................................showLRelationshipColumns....................................
  showRelationshipColumns() {
    this.gridRelationship.columnChooserModule.openColumnChooser(200, 50);
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
